// Form validation composable
export function useFormValidation() {
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!email || typeof email !== 'string') {
      return { isValid: false, error: 'Email is required' }
    }
    
    if (!emailRegex.test(email)) {
      return { isValid: false, error: 'Please enter a valid email address' }
    }
    
    if (email.length > 255) {
      return { isValid: false, error: 'Email is too long' }
    }
    
    return { isValid: true }
  }

  const validateState = (state) => {
    const validStates = [
      'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
      'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho',
      'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana',
      'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
      'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada',
      'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
      'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon',
      'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
      'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
      'West Virginia', 'Wisconsin', 'Wyoming', 'District of Columbia'
    ]
    
    if (!state || typeof state !== 'string') {
      return { isValid: false, error: 'Please select your state' }
    }
    
    if (!validStates.includes(state)) {
      return { isValid: false, error: 'Please select a valid state' }
    }
    
    return { isValid: true }
  }

  const validateAgencyName = (agencyName) => {
    if (agencyName === null || agencyName === undefined || agencyName === '') {
      return { isValid: true } // Optional field
    }
    
    if (typeof agencyName !== 'string') {
      return { isValid: false, error: 'Agency name must be a string' }
    }
    
    if (agencyName.length > 100) {
      return { isValid: false, error: 'Agency name must be less than 100 characters' }
    }
    
    return { isValid: true }
  }

  const validateForm = (formData, errors) => {
    let isValid = true
    
    // Clear previous errors
    Object.keys(errors).forEach(key => {
      errors[key] = ''
    })
    
    // Validate email
    const emailResult = validateEmail(formData.email)
    if (!emailResult.isValid) {
      errors.email = emailResult.error
      isValid = false
    }
    
    // Validate state
    const stateResult = validateState(formData.state)
    if (!stateResult.isValid) {
      errors.state = stateResult.error
      isValid = false
    }
    
    // Validate agency name
    const agencyResult = validateAgencyName(formData.agency_name)
    if (!agencyResult.isValid) {
      errors.agency_name = agencyResult.error
      isValid = false
    }
    
    return isValid
  }

  const clearErrors = (errors) => {
    Object.keys(errors).forEach(key => {
      errors[key] = ''
    })
  }

  return {
    validateEmail,
    validateState,
    validateAgencyName,
    validateForm,
    clearErrors
  }
}
